import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type ProductVariantPriceRangeFragment = { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } };

export const ProductVariantPriceRangeFragmentDoc = gql`
    fragment ProductVariantPriceRangeFragment on VariantPriceRangeType {
  id
  currency
  discount {
    max
    min
  }
  undiscount {
    max
    min
  }
}
    `;